import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ScheduleSlot from './schedule_slot';

function t(key) {
  return I18n.t(`drivers.schedule_form.${key}`);
}

export default class ScheduleElement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      available: !!props.schedule.id,
      allDay: props.schedule.all_day,
      slots: props.schedule.slots,
    };
    this.state.slots = _.isEmpty(this.state.slots) ? [{}] : this.state.slots;
    this.onTrashClick = this.onTrashClick.bind(this);
    this.onPlusClick = this.onPlusClick.bind(this);
    this.onAvailableChange = this.onAvailableChange.bind(this);
    this.onAllDayChange = this.onAllDayChange.bind(this);
    this.onSlotChange = this.onSlotChange.bind(this);
  }

  onTrashClick(index) {
    this.state.slots.splice(index, 1);
    this.setState({ slots: this.state.slots });
  }

  onPlusClick() {
    this.state.slots.push({});
    this.setState({ slots: this.state.slots });
  }

  onAvailableChange(e) {
    this.setState({ available: e.target.checked });
  }

  onAllDayChange(e) {
    this.setState({ allDay: e.target.value === 'true' });
  }

  onSlotChange(index, slot) {
    this.state.slots.splice(index, 1, slot);
    this.setState({ slots: this.state.slots });
  }

  slotsString() {
    const slots = _.filter(this.state.slots, slot => slot.start && slot.end);
    if (this.state.allDay || _.isEmpty(slots)) { return '[]'; }
    return JSON.stringify(slots);
  }

  partialSlots() {
    if (this.state.allDay) { return null; }
    const { slots } = this.state;
    return (
      <div className="day-time">
        <div className="time-header">
          <label htmlFor="from" id="from" className="control-label">{t('from')}</label>
          <label htmlFor="to" id="to" className="control-label">{t('to')}</label>
        </div>

        <div className="time-rows">
          {_.map(slots, (slot, index) => (
            <ScheduleSlot
              key={index}
              index={index}
              slot={slot}
              onPlusClick={this.onPlusClick}
              onTrashClick={this.onTrashClick}
              buttonType={index === slots.length - 1 ? 'plus' : 'trash'}
              onSlotChange={this.onSlotChange}
            />
          ))}
        </div>
      </div>
    );
  }

  details() {
    if (!this.state.available) { return null; }
    const { index } = this.props;
    return (
      <div>
        <div className="day-type">
          <input type="hidden" name={`driver[driver_schedules_attributes][${index}][day]`} value={this.props.schedule.day} />
          <div className="custom-radio">
            <label htmlFor={`driver_schedule_${index}_all_day`}>
              <input
                id={`driver_schedule_${index}_all_day`}
                className="real-radio"
                type="radio"
                name={`driver[driver_schedules_attributes][${index}][all_day]`}
                value="true"
                checked={this.state.allDay}
                onChange={this.onAllDayChange}
              /> {t('all_day')}
              <div className="fake-radio" />
            </label>
          </div>

          <div className="custom-radio">
            <label htmlFor={`driver_schedule_${index}_partial`}>
              <input
                id={`driver_schedule_${index}_partial`}
                className="real-radio"
                type="radio"
                name={`driver[driver_schedules_attributes][${index}][all_day]`}
                value="false"
                checked={!this.state.allDay}
                onChange={this.onAllDayChange}
              /> {t('partial')}
              <div className="fake-radio" />
            </label>
          </div>
        </div>
        <input type="hidden" name={`driver[driver_schedules_attributes][${index}][slots_as_json]`} value={this.slotsString()} />
        {this.partialSlots()}
      </div>
    );
  }

  destroyedInput() {
    if (this.state.available || !this.props.schedule.id) { return null; }
    return <input type="hidden" value="true" name={`driver[driver_schedules_attributes][${this.props.index}][_destroy]`} />;
  }

  idInput() {
    const { schedule, index } = this.props;
    if (!schedule.id) { return null; }
    return (<input type="hidden" name={`driver[driver_schedules_attributes][${index}][id]`} value={schedule.id || ''} />);
  }

  render() {
    const { schedule, index } = this.props;

    return (
      <div className="week-sch-day">
        {this.idInput()}
        <h3>{t(`days.${schedule.day}`)}</h3>
        <div className="week-sch-options">
          <div className="day-available">
            <div className="custom-checkbox">
              <label htmlFor={`driver_schedule_${index}_available`}>
                <input
                  id={`driver_schedule_${index}_available`}
                  className="real-checkbox"
                  type="checkbox"
                  onChange={this.onAvailableChange}
                  checked={this.state.available}
                />{t('available')}
                <div className="fake-checkbox" />
              </label>
            </div>
            {this.destroyedInput()}
          </div>
          {this.details()}
        </div>
      </div>
    );
  }
}

export const scheduleShape = PropTypes.shape({
  id: PropTypes.number,
  all_day: PropTypes.boolean,
  slots: PropTypes.arrayOf(PropTypes.shape({
    start: PropTypes.string,
    end: PropTypes.string,
  })),
});

ScheduleElement.propTypes = {
  schedule: scheduleShape.isRequired,
  index: PropTypes.number.isRequired,
};
